module.exports = __webpack_public_path__ + "img/oriaskigyo80.dfcf5b91.jpg";